import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { AlertRule, AlertRuleProps, AlertRuleUpdate } from './alertRulesTypes';

const alertRulePayloadCreator = getPayloadCreator<AlertRule>();
const alertRuleBatchPayloadCreator = getPayloadCreator<AlertRule[]>();
const alertRulePayloadCreatorUpdate = getPayloadCreator<AlertRuleUpdate>();
const syncAlertRulePayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<AlertRuleProps>>();

export const getAlertRules = createAction('GET_ALERT_RULES', getPayloadCreator());
export const getAlertRulesSuccess = createAction('GET_ALERT_RULES_SUCCESS', syncAlertRulePayloadCreator);
export const getAlertRulesFailure = createAction('GET_ALERT_RULES_FAILURE', errorPayloadCreator);

export const updateAlertRule = createAction('UPDATE_ALERT_RULE', alertRulePayloadCreatorUpdate);
export const updateAlertRuleSuccess = createAction('UPDATE_ALERT_RULE_SUCCESS', alertRulePayloadCreator);
export const updateAlertRuleFailure = createAction('UPDATE_ALERT_RULE_FAILURE', errorPayloadCreator);

export const batchAlertRules = createAction('BATCH_ALERT_RULES', alertRuleBatchPayloadCreator);
export const batchAlertRulesSuccess = createAction('BATCH_ALERT_RULES_SUCCESS', alertRuleBatchPayloadCreator);
export const batchAlertRulesFailure = createAction('BATCH_ALERT_RULES_FAIlURE', errorPayloadCreator);

export const pauseAlertRules = createAction('PAUSE_ALERT_RULES', getPayloadCreator<boolean>());
